import {IColor} from "./tools";
import img5 from "shared/assets/img/bricks/101820.png";
import img4 from "shared/assets/img/bricks/53565a.png";
import img3 from "shared/assets/img/bricks/63666a.png";
import img2 from "shared/assets/img/bricks/97999b.png";
import img1 from "shared/assets/img/bricks/fff1de.png";
const sign0="";

export interface IGreyPalette {
    br: number,
    color: IColor,
    icon: string,
    id: number | string,
    img: string;
}

export const palleteNormalize = (pal:IGreyPalette[]) => {
  let min = 255, max = 0;
  pal.forEach(item => {
    if (item.br > max) { max = item.br; }
    if (item.br < min) { min = item.br; }
  })
  return pal.map(item => ({
    ...item,
    br: 255 * (item.br - min) / (max - min)
  }))
}

export const palette: Record<any, IGreyPalette[]> = {
  default: palleteNormalize([
    {
      br: 243, //e6
      color: {r: 255, g: 241, b: 222},
      icon: sign0,
      img: img1,
      id: 0
    },
    {
      br: 152, //b8
      color: {r: 151, g: 153, b: 155},
      icon: sign0,
      img: img2,
      id: 1
    },
    {
      br: 102, //83
      color: {r: 99, g: 102, b: 106},
      icon: sign0,
      img: img3,
      id: 2
    },
    {
      br: 86, //55
      color: {r: 83, g: 86, b: 90},
      icon: sign0,
      img: img4,
      id: 3
    },
    {
      br: 23, //2a
      color: {r: 16, g: 24, b: 32},
      icon: sign0,
      img: img5,
      id: 4
    }
  ]),
}
